module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.2.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.12.0.0.box.182.708.316.72.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.12.0.0.box.182.708.316.72.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.3.0"
    }
  }), _vm._v("Preface")]), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1.w.0.0.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.171.901.1209.1345.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.0.box.171.901.1209.911.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR1.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1.w.1.0.0"
    }
  }), _vm._v("History, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR1.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1.w.3.0.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.1.0.0"
    }
  }), _vm._v("Skeptic ")]), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.0.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.1.0.0"
    }
  }), _vm._v("Warns, ")]), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.5.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.6.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0"
    }
  }), _vm._v("is written by the survivors. Should the liberal faith survive these troubled times and continue to dominate the intellectual life of the nation, it can be assumed that the exalted place in American history already awarded our modern, politically activist Supreme Court will be secure. It is possible, however, that American historical scholarship will return to an older tradition of belief in rule by representative government rather than by a nonelected intellectual elite and its judicial collaborators. In such case, there will be little sympathy for the currently popular concept of judicial activism as a proper instrument for reforming the political and social order. In the future, no less than at present, the conservative view of the \"Warren Revolution,\" as it has been called by L. Brent Bozell in his book of that title—or simply \"Warrenism,\" as other critics have named this judicial venture into politics—will be less than flattering.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.172.1821.1207.425.q.70"
    }
  }, [_vm._v("One certain verdict of conservative historians, if such survive, will be that Earl Warren and his colleagues could not have been the heroic reformers acclaimed by their liberal admirers, because the hero in history is always the leader rather than the follower or the prisoner of another's ambition. Members of the Warren Court had no independent will of their own but were prisoners of the will of the restless, ambitious, power-seeking leaders of the contemporary liberal-left"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.13.1.0.box.174.287.1204.573.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.0.0"
    }
  }), _vm._v("\ncoalition. This coalition was made up of the intellectual class—the verbalists of the academy, media, pulpit, and bureaucracies; their allies of the left-leaning special interest pressure groups such as the "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Afl-cio, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Naacp, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Aclu, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Nea, ")]), _vm._v("and "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Ncc; ")]), _vm._v("subservient politicians; and utopian activists generally. It may be that history will judge that the Supreme Court under Earl Warren was little more than a transmission belt, a means of effecting a massive transfer of political power from elected representatives of the people at federal and especially state and local levels to this same liberal-left coalition.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.1.0.box.171.287.1207.1996.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.1.box.175.882.1202.532.q.60"
    }
  }, [_vm._v("A transmission of power must have taken place because after the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Brown ")]), _vm._v("decision of l954 the publishers of the Washington "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Post ")]), _vm._v("or the attorneys of the "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Naacp ")]), _vm._v("Legal Defense Fund or the members of the Harvard law faculty had more real authority over the school systems of the state of Alabama, say, or its police powers or its internal security arrangements than did the governor, the state legislature, the state courts, the school board members, or the hundreds of other elected state and local officials. Earl Warren and his colleagues, aided by earlier rulings of the New Deal Court, made this possible.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.2.box.171.1420.1207.863.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.2.0"
    }
  }), _vm._v("Our Supreme Court today has placed itself in a highly controversial and vulnerable political position, because it has given way to the pressures exerted upon it by liberal activists supported by the whole of the left political spectrum. In their drive for utopia, the liberal-left groups had been unable to work their will altogether with Congress and the executive and had therefore brought pressures to bear upon the Supreme Court, forcing it to subordinate its role as an impartial court of justice and to convert itself into a political power center in competition with the political branches and the elected state governments. Pressure from the left has driven the Court to the brink of constitutional anarchy, as evidenced by a l968 speech of the then chief justice Earl Warren at New York University Law School in which he declared that the Supreme Court's essential function is \"to act as a final arbiter of minority rights,\" and that the Court stood ready"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.14.1.0.box.177.306.1195.88.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.0.0"
    }
  }), _vm._v("\nto advance minority interests \"if the executive and legislative branches falter.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.172.306.1207.1986.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.177.414.1197.152.q.70"
    }
  }, [_vm._v("It would be difficult to find a more confused statement of the duties of our highest court as laid down in the Constitution. Certain obvious questions come to mind immediately:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.176.575.1197.206.q.60"
    }
  }, [_vm._v("Where are the constitutional rights "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _vm._v("the majority—the stable, productive, law-abiding, tax-paying members of the middle and working classes who provide the strength and continuity that sustain the national life?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.3.box.177.790.1197.318.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.3.0"
    }
  }), _vm._v("What authority does the Court have to assume the duties of the other branches, and who is to determine if these branches have faltered? What has happened to the reserved rights of the states which lie at the heart of our constitutional system and without which the Constitution would never have been adopted?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.4.box.176.1117.1203.692.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.4.0"
    }
  }), _vm._v("How is the term \"minority\" to be defined? Does it include the farmers, the suburban middle class, the southern whites, or the Indians on reservations, each of which is a distinct economic or racial minority of the total population? Apparently not, because decisions of the Supreme Court in recent years seem to indicate that the term as used by Chief Justice Warren in his speech includes only the currently fashionable groups which the liberals have made the special objects of their affections. For the most part these groups possess a strong political leverage that can be controlled by the liberal leadership; but they include also unstable elements living on the fringes of society or outside the law who provide ideal objects for the outpourings of liberal pity.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.5.box.172.1817.1203.475.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.5.0"
    }
  }), _vm._v("The Warren Court, while posing as liberal, which in the older sense of the term meant belief in freedom, was actually reactionary in that its decisions tended to consolidate power in the central government, thereby restricting the freedom of the states, local governments, and the people. When the exercise of arbitrary power by a handful of appointed judges, acting as agents of private interest groups, is carried on in the name of freedom, then language has lost all meaning in this so-called democracy as it has in the Communist states."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.0.box.177.285.1201.208.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.0.0"
    }
  }), _vm._v("\nOur politicized judiciary needs to be reminded of Thomas Hobbes' famous aphorism: \"Freedom is political power divided into small fragments.\" It is not political power concentrated in the hands of a few appointed judges.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.1.0.box.172.285.1211.750.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.1.box.172.502.1211.533.q.70"
    }
  }, [_vm._v("Our constitutional system has been subverted by the judicial tyranny that Jefferson feared, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("i.e., ")]), _vm._v("the alleged superior wisdom of a small group of appointed judges over that of the thousands of elected representatives of the people in the federal, state, and local governments. Because the human thirst for power is insatiable, it is certain that this unlawful extension of the judicial authority will continue and become increasingly menacing to stable government and public order unless the Court is contained and forced to return to its prescribed duties under the Constitution.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.0.0.box.520.604.818.456.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "122%",
      "text-indent": "1em",
      "text-align": "center"
    },
    attrs: {
      "id": "para.16.0.0.box.520.604.818.456.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _vm._v("WARREN COURT "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _vm._v("CONSTITUTION")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47129707","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 57
// module chunks = 0